import React, { useCallback, useState } from "react";
import { Container } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import styles from "./FormComponent.module.scss";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { fetchRequest } from "utils/restApiCleintAxios";
import { useTypedDispatch } from "store";
import { setTriggerAlert } from "store/users/slice";

const schema = yup.object().shape({
  name: yup.string().required("שדה חובה"),
  email: yup.string().email('כתובת הדוא"ל לא תקינה').required("שדה חובה"),
  phone: yup
    .string()
    .required("שדה חובה")
    .matches(/^[+0-9][0-9]+[+0-9]$/, {
      message: "יש להכניס ספרות בלבד"
    })
});

const defaultVal = {
  name: "",
  email: "",
  message: "",
  phone: ""
};

interface Props {
  onSuccess?: () => void;
  variant?: "default" | "compact";
}

function FormComponent({ onSuccess, variant }: Props) {
  const [phoneErr, setPhoneErr] = useState("");
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    defaultValues: defaultVal,
    resolver: yupResolver(schema)
  });

  const dispatch = useTypedDispatch();

  const onSubmit = useCallback(
    async (data: any) => {
      try {
        if (
          (data?.phone?.length >= 2 && (data?.phone[0] !== "0" || data?.phone[1] !== "5")) ||
          data?.phone?.length < 10
        ) {
          return setPhoneErr("טלפון לא תקין");
        }
        setPhoneErr("");
        await fetchRequest("api/Global/ContactUs", {
          method: "post",
          data
        });
        reset();
        onSuccess && onSuccess();
      } catch {
        dispatch(
          setTriggerAlert({
            show: true,
            title: "Something went wrong"
          })
        );
      }
    },
    [dispatch, onSuccess, reset]
  );

  return (
    <Container id="contact-us">
      <div className={`${styles.formSection} ${variant === "compact" ? styles.compact : ""}`}>

      <h2>עדיין יש לך שאלות?</h2>
        <form className={styles.formWrapper}>
          <Controller
            name="name"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <input
                type="text"
                placeholder="שם מלא"
                className={`${styles.customInput} ${errors.name ? styles.invalidInput : ""}`}
                {...field}
              />
            )}
          />
          <Controller
            name="email"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <input
                type="text"
                placeholder="דוא”ל"
                className={`${styles.customInput} ${errors.email ? styles.invalidInput : ""}`}
                {...field}
                pattern="[A-Za-z]"
                onChange={(e) => {
                  const re = /^[A-Za-z0-9._%+-@]+$/;
                  if (e.target.value === "" || re.test(e.target.value)) field.onChange(e);
                }}
              />
            )}
          />
          <Controller
            name="phone"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <input
                type="phone"
                placeholder="מספר נייד"
                className={`${styles.customInput} ${errors.phone ? styles.invalidInput : ""}`}
                {...field}
                onChange={(e) => {
                  if (e.target.value === "e") return;
                  if (
                    !field.value &&
                    e.target.value.length <= 10 &&
                    Number(Number(e.target.value) - 1)
                  ) {
                    return setValue("phone", `${e.target.value}`);
                  }
                  if (!e.target.value || e.target.value === "0") {
                    return field.onChange(e);
                  }
                  if (
                    e?.target?.validity?.valid &&
                    !!Number(e.target.value) &&
                    field?.onChange &&
                    e.target.value.length <= 10
                  ) {
                    field.onChange(e);
                  }
                }}
              />
            )}
          />
          {!!phoneErr && (
            <div className={styles.validationContainer}>
              <span className={styles.validationText}>*{phoneErr}</span>
            </div>
          )}
          <Controller
            name="message"
            control={control}
            render={({ field }) => (
              <textarea
                placeholder="הודעה"
                className={styles.customInput}
                rows={4}
                {...field}></textarea>
            )}
          />
          <button
            className={`btn-lg btn-lg-secondary ${styles.submitBtn}`}
            onClick={handleSubmit(onSubmit)}>
            שלח
          </button>
        </form>
      </div>
    </Container>
  );
}

export default FormComponent;
